"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SexControl = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ramda = require("ramda");
var _Input = _interopRequireDefault(require("../../../../../../../ui/Input"));
var _Select = _interopRequireDefault(require("../../../../../../../ui/Select"));
var _styles = _interopRequireDefault(require("../../styles.scss"));
var _constants = require("../../constants");
var _LabelControl = _interopRequireDefault(require("../LabelControl"));
var _calendar = _interopRequireDefault(require("./img/calendar.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SexControl = exports.SexControl = function SexControl(_ref) {
  var value = _ref.value,
    errorMsg = _ref.errorMsg,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange;
  var _useTranslation = (0, _reactI18next.useTranslation)('BOOKING_FORM_BY_OPERATOR'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_LabelControl.default, {
    className: (0, _classnames.default)(_styles.default.sex, _styles.default.label),
    label: t('SEX_CONTROL_LABEL')
  }, value === _constants.SEX_TYPES.CHILD.value ? /*#__PURE__*/_react.default.createElement(_Input.default, {
    readOnly: true,
    errorMsg: errorMsg,
    value: _constants.SEX_TYPES.CHILD.label
  }) : /*#__PURE__*/_react.default.createElement(_Select.default, {
    className: _styles.default.select,
    hasError: Boolean(errorMsg),
    icon: _calendar.default,
    items: (0, _ramda.map)((0, _ramda.applySpec)({
      value: (0, _ramda.prop)('value'),
      content: (0, _ramda.prop)('label')
    }), [_constants.SEX_TYPES.MR, _constants.SEX_TYPES.MRS]),
    value: value,
    onChange: onChange,
    onBlur: onBlur
  }));
};
SexControl.propTypes = {
  value: _propTypes.default.string.isRequired,
  onBlur: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired,
  errorMsg: _propTypes.default.string
};